'use client';

import { Box, Skeleton } from '@skin-seoul/design-system';
const BannerListSkeleton = () => {
  return <Box width="100%" height="100%" position="relative" data-sentry-element="Box" data-sentry-component="BannerListSkeleton" data-sentry-source-file="BannerListSkeleton.tsx">
      <Skeleton width="100%" height="100%" borderRadius="0" data-sentry-element="Skeleton" data-sentry-source-file="BannerListSkeleton.tsx" />
    </Box>;
};
export default BannerListSkeleton;